import { render, staticRenderFns } from "./JgpAlbum.vue?vue&type=template&id=97740e1e&scoped=true&"
import script from "./JgpAlbum.vue?vue&type=script&lang=js&"
export * from "./JgpAlbum.vue?vue&type=script&lang=js&"
import style0 from "./JgpAlbum.vue?vue&type=style&index=0&id=97740e1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97740e1e",
  null
  
)

export default component.exports